/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Components
import GenericMenu from 'ui/components/main-menu/GenericMenu.vue';

/**
 * ApplicationMenu component, used to display list of global and general links.
 *
 * @example
 * ApplicationMenu(:modules="modules" :current="currentPage")
 *
 * @vue-prop {Object} modules an object containing all available modules.
 * @vue-prop {Object} current the current page configuration.
 *
 * @category ui.components.main-menu
 * @exports ApplicationMenu
 * @component
 */
const __vue_script__ = {
    name: 'ApplicationMenu',

    extends: GenericMenu,

    data() {
        return {
            hoverPage: '',
            pages: []
        };
    },

    created() {
        this.pages = this.$utils.collections.sortByOrder(this.modules, 'name')

            // Pick only modules that declare controllers.
            .filter(page => page.controllers && page.type === 'global')

            // Filter out all pages that don't apply to the current user role
            .filter(page => !page.roles || this.$services.user.matchesRoles(page.roles));
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sidemenu"},[_vm._t("heading"),_c('div',{staticClass:"menus"},[_c('div',{staticClass:"top-level-menu"},[_c('ul',_vm._l((_vm.pages),function(page){return _c('li',{key:page.title,class:[_vm.matchesRoute(page) ? 'selected' : ''],on:{"mouseover":function($event){_vm.hoverPage = page.title},"mouseleave":function($event){_vm.hoverPage = ''}}},[_c('v-popover',{attrs:{"disabled":!(_vm.hoverPage == page.title && _vm.parentMinified),"open":true,"delay":{show: 100, hide: 100},"placement":"auto","popover-class":"tooltip-comp menu-tooltip"}},[_c('template',{slot:"popover"},[_c('p',[_vm._v(_vm._s(_vm.$t(page.label)))])])],2),_c('a',{attrs:{"href":_vm.getLink(page),"data-cue":page.name}},[(page.icon)?_c('i',{class:page.icon}):_vm._e(),_c('span',{staticClass:"text"},[_vm._v(_vm._s(_vm.$t(page.label)))])])],1)}),0)])]),_vm._t("baseline")],2)}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "ApplicationMenu.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__